/*
 * --------------------------------------------------------------------
 * File: \src\app\appSlice.js
 * Created: Wednesday, 25th September 2024 12:26:33 pm
 * Modified: Wednesday, 25th September 2024 12:26:33 pm
 * Author: Mohamed Kamil Bin Mansor
 * 
 * Copyright (c) 2024 - System Consultancy Services Sdn. Bhd.
 * --------------------------------------------------------------------
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    panel : null,
    currData: null,
    subData : null,
    sideSubData : null,
    roles : null,
    status : null,
    council : null,
    userCouncil : null,
    mainLoading : false,
    modules : null,
    submodules : null,
    userAccessId : null,
}

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setPanel: (state, action) => {
      state.panel = action.payload;
    },
    setCurrData : (state,action) => {
      state.currData = action.payload
    },
    setSubData : (state,action) => {
      state.subData = action.payload
    },
    setSideSubData : (state,action) => {
      state.sideSubData = action.payload
    },
    setRoles : (state,action) => {
      state.roles = action.payload
    },
    setStatus : (state,action) => {
      state.status = action.payload
    },
    setCouncil : (state,action) => {
      state.council = action.payload
    },
    setUserCouncil : (state,action) => {
      state.userCouncil = action.payload
    },
    setModules : (state,action) => {
      state.modules = action.payload
    },
    setSubModules : (state,action) => {
      state.submodules = action.payload
    },
    setMainLoading : (state,action) =>{
      state.mainLoading = action.payload
    },
    setUserAccessId : (state,action) => {
      state.userAccessId = action.payload
    }
  },
});

export const { 
    setPanel,  
    setCurrData,
    setSubData,
    setSideSubData,
    setRoles,
    setStatus,
    setCouncil,
    setUserCouncil,
    setModules,
    setSubModules,
    setMainLoading,
    setUserAccessId,

} = adminSlice.actions;

export const getPanel = (state) => state.admin.panel;
export const getCurrData = (state) => state.admin.currData;
export const getSubData = (state) => state.admin.subData;
export const getSideSubData = (state) => state.admin.sideSubData;
export const getRoles = (state) => state.admin.roles;
export const getStatus = (state) => state.admin.status;
export const getCouncil = (state) => state.admin.council;
export const getUserCouncil = (state) => state.admin.userCouncil;
export const getMainLoading = (state) => state.admin.mainLoading;
export const getModules = (state) => state.admin.modules;
export const getSubModules = (state) => state.admin.submodules;
export const getUserAccessId = (state) => state.admin.userAccessId;

export default adminSlice.reducer;